import React, { useState, useRef, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { ChangeLanguage } from "../../utils/ChangeLanguage";



const LanguageIcon = ({ className = "w-4 h-4" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={className}>
  <path strokeLinecap="round" strokeLinejoin="round" d="M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 0 0-8.862 12.872M12.75 3.031a9 9 0 0 1 6.69 14.036m0 0-.177-.529A2.25 2.25 0 0 0 17.128 15H16.5l-.324-.324a1.453 1.453 0 0 0-2.328.377l-.036.073a1.586 1.586 0 0 1-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 0 1-5.276 3.67m0 0a9 9 0 0 1-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25" />
</svg>


);



const CheckCircle = ({className = "w-4 h-4" }) => (

  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={className}>
  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>


);


const languageList = [

  { code: "en", name: "English", flag: <LanguageIcon />, dir: "ltr"},

  { code: "fa", name: "فارسی", flag:  <LanguageIcon />, dir: "rtl" }

];


const Language: React.FC = () => {

  const { i18n } = useTranslation();

  const [open, setOpen] = useState(false);

  const ref = useRef<HTMLDivElement>(null);

  
  const currentLang = languageList.find(l => l.code === i18n.language);
  
  const isRtl = languageList.find(l => l.code === i18n.language).dir === "rtl";

  const handleChangeLanguage = async (langCode: string) => {

    await ChangeLanguage(langCode as "en" | "fa");

    setOpen(false);

  };


  useEffect(() => {

    const handleClickOutside = (e: MouseEvent) => {

      if (ref.current && !ref.current.contains(e.target as Node)) {

        setOpen(false);

      }

    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);

  }, []);


  return (

    <div className="relative inline-block" ref={ref}>



      <button

        onClick={() => setOpen(p => !p)}

        className="flex items-center gap-2 px-3 py-1.5

rounded-full bg-white/70 backdrop-blur-md

shadow-sm hover:shadow-md transition-all duration-200

border border-gray-200 hover:scale-105"

      >

        {currentLang?.flag}

        <span className="text-xs font-medium text-gray-700 mt-1">

          {currentLang?.code.toUpperCase()}

        </span>

      </button>



      <div className={`bg-white absolute mt-2 md:p-2  p-1 md:w-40 w-24 rounded-2xl bg-white/80 backdrop-blur-md border border-gray-200 shadow-lg transition-all duration-200 origin-top
        ${open ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"} ${isRtl ? "left-0 lg:right-0" : "right-0 lg:left-0"}`}>

        {languageList.map(lang => (

          <button
            key={lang.code}
            onClick={() => handleChangeLanguage(lang.code)}
            className={`w-full flex items-center gap-2 md:px-3 px-1 py-2 md:text-sm text-xs hover:bg-gray-100/70 transition ${lang.code === i18n.language && "bg-gray-100/80 font-semibold"}`}>
            {  <CheckCircle className={`w-4 h-4 text-green ${lang.code == i18n.language ? 'block' : 'invisible'}`}/> }
            <span className="text-center mt-2">{lang.name}</span>

          </button>

        ))}

      </div>

    </div>

  );

};


export default Language;